import { ROUTE_NAMES } from "@/router/routes";
import { useTerminalsStore } from "@/stores/terminals";
import { useUiStore } from "@/stores/ui";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";

export function useTerminals() {
  const terminalsStore = useTerminalsStore();
  const uiStore = useUiStore();
  const router = useRouter();

  const { terminalOperationId: operationId } = storeToRefs(uiStore);
  const { terminalsList, terminalsByKey } = storeToRefs(terminalsStore);

  /**
   * Redirects the user to the correct terminal, and sets up the state for said terminal view.
   * @param newTerminalId The new terminal id to go to, or null if going to default
   */
  async function goToTerminal(newTerminalId: number | undefined) {
    if (terminalsList.value.length === 0) await terminalsStore.getTerminals();

    if (newTerminalId == null) {
      newTerminalId = localStorage.lastUsedTerminalId
        ? localStorage.lastUsedTerminalId
        : undefined;
    }

    operationId.value = null;

    if (typeof newTerminalId !== "undefined") {
      terminalsStore.setActiveTerminal(terminalsByKey.value[newTerminalId]);

      router.replace({
        name: ROUTE_NAMES.OPERATIONSELECT,
        params: { terminalId: newTerminalId },
      });
    } else {
      router.replace({
        name: ROUTE_NAMES.HOME,
      });
    }
  }

  return { goToTerminal };
}
